import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IPointMangement } from '../interfaces/IPointManagmet';
import { ApiResponse } from '@shared';

@Injectable({
  providedIn: 'root',
})
export class PointManagmentService {
  constructor(private http: HttpClient) {}

  getPointManagementData() {
    return this.http.get<ApiResponse>(`/v1/admin/point-managment`);
  }

  updatePointManagment(id: string, pointManagmentData: IPointMangement) {
    return this.http.put<ApiResponse>(`/v1/admin/point-managment/${id}`, pointManagmentData);
  }
}
